import React from 'react';
import { HeroSection } from '../components/home/HeroSection';
import { StatsSection } from '../components/home/StatsSection';
import { FeaturedProjects } from '../components/home/FeaturedProjects';
import { LatestBids } from '../components/home/LatestBids';
import { ProcurementQuickLinks } from '../components/home/ProcurementQuickLinks';
import { NewsSection } from '../components/home/NewsSection';
import { CTASection } from '../components/home/CTASection';
export function Home() {
  return <div data-id="element-729">
      <HeroSection data-id="element-730" />
      <StatsSection data-id="element-731" />
      <FeaturedProjects data-id="element-732" />
      <LatestBids data-id="element-733" />
      <ProcurementQuickLinks data-id="element-734" />
      <NewsSection data-id="element-735" />
      <CTASection data-id="element-736" />
    </div>;
}